/**
 * Helpers de presentación para campos de formulario.
 *
 * Traducen el objeto `errors` de `useForm` a las props que esperan los
 * componentes de entrada (Material-UI TextField y AutocompleteComponent),
 * evitando repetir el bloque `{ error: !!errors[name], helperText: errors[name] }`
 * en cada campo.
 */

/**
 * Genera las props de error para un campo de formulario.
 *
 * - `TextField`: esparce el resultado directamente sobre el componente.
 *   `<TextField {...getFieldErrorProps(errors, "name")} />`
 * - `AutocompleteComponent`: pásalo a la prop `textFieldProps`.
 *   `<AutocompleteComponent textFieldProps={getFieldErrorProps(errors, "name")} />`
 *
 * @param {Object} errors - Objeto de errores de validación (de useForm).
 * @param {String} name   - Nombre del campo a consultar.
 * @returns {{ error: boolean, helperText: string }} Props listas para el input.
 */
export const getFieldErrorProps = (errors = {}, name = "") => ({
  error: !!errors[name],
  helperText: errors[name] || "",
});
